// extracted by mini-css-extract-plugin
module.exports = {"text":"SellYourParts_text__4Hv_h","call_to_action_links":"SellYourParts_call_to_action_links__0Th2y"};